const createTableTokens = ({ borderWidths }) => ({
  borderWidths: {
    row: borderWidths[1],
  },
  borderStyles: {
    row: 'dashed',
  },
});

export default createTableTokens;
